import {
  effect,
  Injectable,
  Injector,
  runInInjectionContext,
  signal,
} from '@angular/core'
import {
  DialogOptions,
  ModalResponse,
  NgModalServiceInterface,
} from '@evologi/shared/data-access-api'
import { DynamicDialogRef } from 'primeng/dynamicdialog'

@Injectable({ providedIn: 'root' })
export class NgModalService implements NgModalServiceInterface {
  // The current modal configuration
  dialogConfig = signal<DialogOptions | null>(null)
  // The user's response
  response = signal<ModalResponse | null>(null)

  ref: DynamicDialogRef | undefined

  constructor(private injector: Injector) {}

  /** Called by components to show the modal */
  showDialog(options: DialogOptions): Promise<ModalResponse> {
    this.dialogConfig.set(options)
    this.response.set(null)

    // Wait for response via Promise
    return new Promise((resolve) => {
      runInInjectionContext(this.injector, () => {
        const watcher = effect(() => {
          const response = this.response()
          if (response) {
            watcher.destroy()
            resolve(response)
          }
        })
      })
    })
  }

  /** Called by the modal host component when user clicks a button */
  respond(value: ModalResponse) {
    this.response.set(value)
    this.dialogConfig.set(null) // hide modal
  }
}
